import React, { useState } from "react";
import { TableContext } from "../../index";
import { debug } from "../../utils";
import ParametersTable from "./ParametersTable";
import ParametersTableHeader from "./ParametersTableHeader";
import { listPageable } from "./parameterService";
import PaginationManager from "../../view/PaginationManager";


function ParametersTableSection() {

    const initTableConfig = {
        selected: [],
        selectAll: false,
    }

    const [tableConfig, setTableConfig] = useState(initTableConfig);

    const changeTableConfig = (config) => {
        debug("Table config changed:", config);
        setTableConfig(config);
    }

    return (
        <TableContext.Provider value={{ config: tableConfig, setConfig: changeTableConfig }}>
            <div className="addrules-content-card-v2 parameters-content-card-v2">
                <ParametersTableHeader />

                <div className="parameters-table-body-v2">
                    <ParametersTable />
                    <PaginationManager getPage={listPageable} />
                </div>
            </div>
        </TableContext.Provider>
    )
}

export default ParametersTableSection;
